import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Button,
} from "@mui/material";

function AddCoinsDialog({
  open,
  addCoinsAmount,
  setAddCoinsAmount,
  addCoinsHandler,
  setOpenAddCoinsDialog,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => setOpenAddCoinsDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Add Coins</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="amount"
              label="Amount"
              fullWidth
              value={addCoinsAmount}
              variant="standard"
              onChange={(e) => setAddCoinsAmount(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenAddCoinsDialog(false)}>Cancel</Button>
        <Button onClick={addCoinsHandler} autoFocus>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddCoinsDialog;
